import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NoticeBoardMeeting } from "../Constant";

const InvestorDropDown = () => {
  const dropDown = [
    {
      name: "Disclosures under Regulation 46 of the LODR",
      sub: [
        {
          subName: "MoA",
          path: "/moa",
          downloadPageName: "MOA.pdf",
        },
        {
          subName: "AoA",
          path: "/aoa",
          downloadPageName: "AOA.pdf",
        },
        {
          subName: "Business Details",
          path: "/business-details",
          downloadPageName: "Business-Detail.pdf",
        },
        {
          subName: "Composition of Committee of Board of Directors",
          path: "/composition-of-committee-of-board-of-directors",
          downloadPageName: "Committees-of-our-Board.pdf",
        },
        {
          subName: "Grievance Redressal",
          downloadPageName: "Investor-Contact-for-grievance-redressal.pdf",
        },
        {
          subName: "Familiarization program for independent directors",
          downloadPageName:
            "Policies/Familiarization-of-Independent-Director.pdf",
        },
        {
          subName: "Policy for detrmining subsidiaries",
          downloadPageName: "Policies/Policy-for-detrmining-subsidiaries.pdf",
        },
        {
          subName:
            "Brief profile of board of directors including directorship and full-time positions in body corporates",
          downloadPageName: "Directorship-Positions.pdf",
        },
        {
          subName: "Terms-conditions-of-Appointment-of-Independent-Directors",
          downloadPageName:
            "Policies/Terms-and-Conditions-for-appointment-of-ID.pdf",
        },
        {
          subName:
            "Code of Conduct for Directors and Senior Management Personnel",
          downloadPageName: "Policies/Code-of-Conduct-Policy.pdf",
        },
        {
          subName: "Whistle Blower Policy",
          downloadPageName: "Policies/WHISTLE-BLOWER-POLICY.pdf",
        },
        {
          subName: "Policy of Making Payments to Non-Executive Directors",
          downloadPageName: "Policies/Policy-Payments.pdf",
        },
        {
          subName: "Email Address for Grievance Redressal",
          downloadPageName: "Investor-Contact-for-grievance-redressal.pdf",
        },
        {
          subName:
            "Contact details of designated Officials handling Investor Grievances",
          downloadPageName: "Disclosure-of-contact-details-of-KMP.pdf",
        },
        {
          subName: "Policy for Determination of Materiality of Events",
          downloadPageName:
            "Policies/Policy-on-Criteria-for-determining-Materiality-of-Events or-Information-for-disclosure-to-Stock-Excha.pdf",
        },
        {
          subName: "Officer Responsible for Determining Materiality",
          downloadPageName: "Materiality-Policy.pdf",
        },
      ],
    },
    {
      name: "Disclosures under Regulation 62 of the LODR",
      sub: [
        {
          subName: "Financial Information",
          path: "/financial-information",
          haschild: true,
        },
        {
          subName: "2021-22",
          downloadPageName: "Financials/Audited-Balance-Sheet_2021-22.pdf",
          parent: "Financial Information",
        },
        {
          subName: "2022-23",
          downloadPageName: "Financials/Audited-Balance-Sheet_2022-23.pdf",
          parent: "Financial Information",
        },
        {
          subName: "2023-24",
          downloadPageName: "Financials/Audited-Balance-Sheet_2023-24.pdf",
          parent: "Financial Information",
        },
        {
          subName: "Key Managerial Personnel",
          path: "/key-managerial-personnel",
          downloadPageName: "Key-Managerial-Personnel.pdf",
        },
        {
          subName: "Annual Return",
          path: "/annual-return",
          navigate: true,
        },
        {
          subName: "Shareholding Pattern",
          path: "/shareholding-pattern",
          navigate: true,
        },
        {
          subName: "Scrutinizer Report",
          path: "/scrutinizer-report",
          navigate: true,
        },
      ],
    },
    {
      name: "Other Investor Information",
      sub: [
        {
          subName: "Code and Policies",
          path: "/code-and-policies",
          navigate: true,
        },
        {
          subName: NoticeBoardMeeting,
          path: "/notice-of-board-meeting",
          navigate: true,
        },
        {
          subName: "Investor Relation",
          path: "/investor-relation",
        },
        {
          subName: "Annual Report",
          path: "/annual-report",
          navigate: true,
        },
        {
          subName: "Financial Results",
          path: "/financial-results",
          navigate: true,
        },
        {
          subName: "Statutory Disclosure",
          path: "/statutory-disclosure",
          parent: "Financial Information",
          haschild: true,
        },
        {
          subName: "Closure of Trading Window",
          path: "/closure-of-trading-window",
          navigate: true,
          parent: "Statutory Disclosure",
        },
      ],
    },
    {
      name: "Other",
      sub: [
        {
          subName: "Press Release",
          path: "/press-release",
          navigate: true,
        },
      ],
    },
    {
      name: "Initial Public Offering",
      sub: [
        {
          subName: "Draft Prospectus",
          downloadPageName:
            "Draft-Prospectus-Essex-Marine-Limited-Filing-version-Final.pdf",
        },

        {
          subName: "Prospectus",
          downloadPageName: "Prospectus.pdf",
        },
        {
          subName: "Paper ad",
          path: "/paper-ad",
          navigate: true,
        },

        {
          subName: "Notices",
          path: "/notices",
          navigate: true,
        },

        {
          subName: "Basis of Allotment Ad",
          path: "/basis-of-allotment-ad",
        },
      ],
    },
    {
      name: "Pre- Issue Advertisment",
      path: "/pre-issue-advertisment",
      sub: [],
    },
  ];

  const [currentDropDown, setCurrentDropDown] = useState(-1);

  const downloadFile = (event, status) => {
    if (status) {
      event.preventDefault();
      const formattedUrl = `https://essexmpl.com/Pdf/${status}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleSubItemClick = (event, subItem) => {
    if (subItem?.downloadPageName) {
      downloadFile(event, subItem.downloadPageName);
    }
  };

  return (
    <ul className="dropdown-menu customDropDown">
      {dropDown.map((item, i) => (
        <li className="customSubDropDown">
          {item.path ? (
            <>
              <Link
                onMouseEnter={() => setCurrentDropDown((prev) => -1)}
                className="customDropDownList"
                to={item.path}
              >
                {item.name}
              </Link>
            </>
          ) : (
            <p onMouseEnter={() => setCurrentDropDown((prev) => item.name)}>
              {item.name}
            </p>
          )}

          {item.name == currentDropDown && (
            <>
              <span className="customIcon">
                <i className="fa-solid fa-angle-right"></i>
              </span>
              {item.sub?.length ? (
                <ul
                  className="subDropDown"
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  {item.sub.map((subItem) => (
                    <li
                      onClick={(e) => handleSubItemClick(e, subItem)}
                      className={`${subItem.parent ? "customInnerSub" : ""} ${
                        subItem.haschild
                          ? "customHasInnerSub hasGrandChild"
                          : ""
                      } `}
                    >
                      <Link to={subItem?.navigate ? subItem.path : "#"}>
                        {subItem.subName}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

export default InvestorDropDown;
